var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDisableCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 1.3125C5.42637 1.3125 1.3125 5.42637 1.3125 10.5C1.3125 15.5736 5.42637 19.6875 10.5 19.6875C15.5736 19.6875 19.6875 15.5736 19.6875 10.5C19.6875 5.42637 15.5736 1.3125 10.5 1.3125ZM14.4683 7.49971L10.1493 13.488C10.089 13.5722 10.0094 13.6409 9.91718 13.6883C9.82499 13.7356 9.72284 13.7603 9.61919 13.7603C9.51554 13.7603 9.41339 13.7356 9.3212 13.6883C9.229 13.6409 9.14943 13.5722 9.08906 13.488L6.53174 9.94424C6.45381 9.83555 6.53174 9.68379 6.66504 9.68379H7.62686C7.83604 9.68379 8.03496 9.78428 8.15801 9.95654L9.61816 11.9827L12.842 7.51201C12.965 7.3418 13.1619 7.23926 13.3731 7.23926H14.335C14.4683 7.23926 14.5462 7.39102 14.4683 7.49971Z",
    fill: "#8C8C8C"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisableCheckCircle);
export default __webpack_public_path__ + "static/media/disable-check-circle.ad13abaf89444cf4f2686ba57583bccd.svg";
export { ForwardRef as ReactComponent };